import { call, select, take } from 'redux-saga/effects';

import { DELETE_HIGHLIGHT } from './actions';

import { deleteHighlight as vsDeleteHighlight } from 'services/learnkit';


function* delete_() {
  while (true) {
    const { data:selHighlightId } = yield take(DELETE_HIGHLIGHT);
    yield select(state => {
      return {
        highlights: state.highlights,
        notes: state.notes
      };
    });

    // LST-1595 make api call and `highlight:deleted` VS event will handle updating redux state
    yield call(vsDeleteHighlight, selHighlightId);
  }
}


export default delete_;
